<rappider-feedback *ngIf="error"
                   [icon]="error.icon"
                   [title]="error.title"
                   [subTitle]="error.description"
                   [buttons]="error.buttons"></rappider-feedback>